// components/contribute/Step1ProblemDetails.js
import DeviceSelector from '../DecviceSelector'
import './StepComponents.css'

function Step1ProblemDetails ({ formData, onChange, disabled }) {
  return (
    <div className='step-content'>
      <div className='step-header'>
        <h2>Problem-Details</h2>
        <p>Beschreiben Sie das technische Problem, das Sie gelöst haben</p>
      </div>

      <div className='form-section'>
        <div className='form-group'>
          <label>
            Gerät auswählen <span className='required'>*</span>
          </label>
          <DeviceSelector
            value={formData.deviceName}
            onChange={value => onChange('deviceName', value)}
            disabled={disabled}
            compact={false}
            showLabel={false}
          />
        </div>

        <div className='form-row'>
          <div className='form-group'>
            <label>
              Kategorie <span className='required'>*</span>
            </label>
            <select
              value={formData.category}
              onChange={e => onChange('category', e.target.value)}
              disabled={disabled}
            >
              <option value='troubleshooting'>Troubleshooting</option>
              <option value='error_code'>Fehlercode</option>
              <option value='maintenance'>Wartung</option>
              <option value='workaround'>Workaround</option>
              <option value='general_knowledge'>Allgemeines Wissen</option>
            </select>
          </div>

          <div className='form-group'>
            <label>Fehlercode (optional)</label>
            <input
              type='text'
              value={formData.errorCode}
              onChange={e => onChange('errorCode', e.target.value)}
              placeholder='z.B. E301'
              disabled={disabled}
            />
          </div>
        </div>

        <div className='form-group'>
          <label>
            Problem-Titel <span className='required'>*</span>
          </label>
          <input
            type='text'
            value={formData.problemTitle}
            onChange={e => onChange('problemTitle', e.target.value)}
            placeholder='Kurze, prägnante Beschreibung'
            maxLength={100}
            disabled={disabled}
            required
          />
          <span className='char-count'>{formData.problemTitle.length}/100</span>
        </div>

        <div className='form-group'>
          <label>Detaillierte Problembeschreibung</label>
          <textarea
            value={formData.problemDescription}
            onChange={e => onChange('problemDescription', e.target.value)}
            placeholder='Was genau ist das Problem? Wann tritt es auf?'
            rows={4}
            disabled={disabled}
          />
          <div className='help-text'>
            Je detaillierter Sie das Problem beschreiben, desto besser können es
            andere Techniker verstehen
          </div>
        </div>
      </div>
    </div>
  )
}

export default Step1ProblemDetails
